import { useLayoutEffect, useState } from 'react'

export default function useDropdownPortal(enabled, open, triggerRef, menuRef) {
    const [position, setPosition] = useState(null)
    useLayoutEffect(() => {
        if (!enabled || !open) return
        const update = () => {
            if (!triggerRef.current || !menuRef.current) return
            const rect = triggerRef.current.getBoundingClientRect()
            const below = Math.max(0, window.innerHeight - rect.bottom - 12)
            const above = Math.max(0, rect.top - 12)
            const upward = below < Math.min(250, menuRef.current.scrollHeight) && above > below
            const maxHeight = Math.min(250, upward ? above : below)
            const width = Math.min(rect.width, window.innerWidth - 16)
            setPosition({
                position: 'fixed',
                top: upward ? undefined : rect.bottom + 4,
                bottom: upward ? window.innerHeight - rect.top + 4 : undefined,
                left: Math.max(8, Math.min(rect.left, window.innerWidth - width - 8)),
                right: 'auto', width, maxHeight, zIndex: 1300,
                '--text': 'var(--text-color)',
                '--text-rgb': 'var(--text-color-rgb)',
                '--open-color': 'var(--background-color)',
            })
        }
        update()
        const observer = new ResizeObserver(update)
        observer.observe(triggerRef.current)
        const onScroll = event => {
            if (!menuRef.current?.contains(event.target)) update()
        }
        window.addEventListener('resize', update)
        window.addEventListener('scroll', onScroll, true)
        return () => {
            observer.disconnect()
            window.removeEventListener('resize', update)
            window.removeEventListener('scroll', onScroll, true)
        }
    }, [enabled, open, triggerRef, menuRef])
    return position
}
